module.exports = __webpack_public_path__ + "static/img/equip-d.544deea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/equip-d.svg
// module id = I5Eq
// module chunks = 3 5